import { IApiResponse } from "../../../@types/api-response.type";
import { getErrorMessage } from "../../../utils/utils";
import { Api } from "../ApiConfig";
import { ApiException } from "../ApiException";

export const startResourceImport = async (type: number) : Promise<IApiResponse<void> | ApiException> => {
    try {
        const { data } = await Api.post<IApiResponse<void>>(`/api/ResourceImport/StartResourceImport`, type);
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao importar Colaboradores'))
    }
}

export const startLgResourceImport = async (type: number) : Promise<IApiResponse<void> | ApiException> => {
    try {
        const { data } = await Api.post<IApiResponse<void>>(`/api/ResourceImport/StartLgResourceImport`, type);
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao importar Colaboradores'))
    }
}